import { render, staticRenderFns } from "./SettingsAbout.vue?vue&type=template&id=472efa72&"
import script from "./SettingsAbout.vue?vue&type=script&lang=js&"
export * from "./SettingsAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports